import React from 'react'
import as91 from '../images/as91.jpg'
import as92 from '../images/as92.jpg'
import as21 from '../images/as21.jpeg'
import as20 from '../images/as20.jpeg'
import as22 from '../images/as22.jpeg'
import as123 from '../images/as123.jpg'
import Header from '../Components/Header'

const About = () => {
  return (
    
     <main className='as'>
      <Header/>
      <section className='about'>
       <div className="about-title">
      <h2 className='mn'>
        о нас
      </h2>
        </div> 
        <div className="container">
        <div className="about-img">
        <img src={as91} />
        </div>
        <div className="about-description">
        <p>
      Компания «МАК СТРОЙ» выполняет качественные
      асфальтные работы любой сложности по всей Москва.
    </p>

    <p>
      Мы предлагаем надежные решения для дорог,
      дворов, парковок и промышленных территорий,
      используя современную технику и качественные материалы.
    </p>

    <p>
      Качество, надежность и соблюдение сроков —
      основа нашей работы.
    </p>
        </div>
       </div>  
      </section>
      <a href="https://wa.me/+79917370144" className="whatsapp-btn" target="_blank" rel="noopener noreferrer">
           <i className="bi bi-whatsapp"></i>
           </a>      
<section className="company-info">

<h2>Почему выбирают МАК СТРОЙ</h2>

<div className="info-grid">

<div className="info-card">
<h3>1000+</h3>
<p>Успешно выполненных проектов</p>
</div>

<div className="info-card">
<h3>10+</h3>
<p>Лет опыта в сфере асфальтирования</p>
</div>

<div className="info-card">
<h3>100%</h3>
<p>Гарантия качества на все работы</p>
</div>

<div className="info-card">
<h3>24/7</h3>
<p>Консультация и поддержка клиентов</p>
</div>

</div>

<h2>Наши преимущества</h2>

<ul>
<li>✓ Современная техника</li>
<li>✓ Опытные специалисты</li>
<li>✓ Качественные материалы</li>
<li>✓ Соблюдение сроков</li>
<li>✓ Бесплатный выезд специалиста</li>
<li>✓ Работаем по всей Армении</li>
</ul>

<h2>Как мы работаем</h2>

<div className="steps">
<div>1. Оставляете заявку</div>
<div>2. Выезд специалиста на объект</div>
<div>3. Расчет стоимости</div>
<div>4. Выполнение работ</div>
<div>5. Сдача готового объекта</div>
</div>

<h2>Отзывы клиентов</h2>

<div className="reviews">

<div className="review">
<p>
Отличная работа! Всё выполнено качественно и в срок.
</p>
<h4>Александр</h4>
</div>

<div className="review">
<p>
Профессиональный подход и современная техника.
</p>
<h4>Сергей</h4>
</div>

<div className="review">
<p>
Очень довольны результатом. Рекомендуем компанию.
</p>
<h4>Игорь</h4>
</div>

</div>

</section>
<section className="guarantee">
  <h2>Гарантии качества</h2>

  <div className="guarantee-box">
    <div>
      <h3>✔ Официальная гарантия</h3>
      <p>Предоставляем гарантию на выполненные работы.</p>
    </div>

    <div>
      <h3>✔ Современная техника</h3>
      <p>Используем профессиональное оборудование.</p>
    </div>

    <div>
      <h3>✔ Качественные материалы</h3>
      <p>Работаем только с проверенными поставщиками.</p>
    </div>

    <div>
      <h3>✔ Соблюдение сроков</h3>
      <p>Всегда выполняем работы в оговоренные сроки.</p>
    </div>
  </div>
</section>
<section className="equipment">

  <h2>НАША ТЕХНИКА</h2>

  <p className="equipment-text">
    Для выполнения работ мы используем современную
    специализированную технику, что позволяет обеспечивать
    высокое качество, скорость и надежность на каждом объекте.
  </p>

  <div className="equipment-list">

    <div className="equipment-card">
      <h3>🚜 Асфальтоукладчики</h3>
      <p>Для качественной укладки асфальтового покрытия.</p>
    </div>

    <div className="equipment-card">
      <h3>🚧 Дорожные катки</h3>
      <p>Для уплотнения и долговечности покрытия.</p>
    </div>

    <div className="equipment-card">
      <h3>🚛 Самосвалы</h3>
      <p>Для перевозки асфальта и строительных материалов.</p>
    </div>

    <div className="equipment-card">
      <h3>🏗 Экскаваторы</h3>
      <p>Для подготовки основания и земляных работ.</p>
    </div>

  </div>

</section>


    <section className='qa'>
   <div className="qa-left">
   <img src={as123} alt="" />
   </div>
   <div className="qa-right">
     <h2 className='ha'>часто задаваемые вопросы</h2>
<br />
    <details>
          <summary>
            Сколько времени занимает выполнение проекта?
          </summary>
          Сроки зависят от объёма и сложности работ. После оценки объекта предоставляется точный график.
          </details>
          <details>
          <summary>
           Какие услуги предоставляет МАК.СТРОЙ?
          </summary>
         Мы выполняем строительство дорог, благоустройство территорий, земляные и строительные работы.
         
          </details>
           <details>
          <summary>
          В каких регионах вы работаете?
          </summary>
            Компания выполняет работы по всей территории МОСКВА
          </details>
          <details>
            <summary>Предоставляете ли вы гарантию на выполненные работы?</summary>
          Да, мы гарантируем качество выполненных работ в соответствии с договором.
          </details>
          <details>
            <summary>Используете ли вы собственную технику?</summary>
          Да, компания располагает собственной строительной и дорожной техникой
          </details>
        

         
   </div>
    </section>
<br /><br />
    <section>
   <h2 className='wwww'>Оставьте заявку на бесплатную консультацию</h2>
   <div className="form">
    <form action="https://formsubmit.co/manvelikavetisyan@gmail.com" method="POST">
     <input type="hidden" name='_next' value="http://localhost:3000/" />
      <input type="text" placeholder='Имя' name='Имя' />
      <input type="text" placeholder='Фамилия' name='Фамилия' />
      <input type="email" placeholder='Электронная почта' name='email' />
      <input type="tel" placeholder='Номер телефона' name='phone' />
      <textarea placeholder='Опишите ваш вопрос или заявку' name='message'></textarea>
      <input  type="submit" value="Отправить заявку" />
    </form>
   </div>
    </section>
     </main>
  )
}


export default About
